function klarnaAfterToolTip() {
  var onSiteContainer = document.getElementById('os-modal-desktop');
  var parentContainer = document.getElementById('parent-container');
  var infoIcon = document.querySelector('.info-icon');
  var closeIcon = document.getElementById('os-close');
  var closeIconMobile = document.getElementById('os-close-mobile'); 

// Text Content
function addInstallmentDetails() {
      kicker_headings = document.querySelectorAll('span.os-kicker-heading');
      pmt_headings = document.querySelectorAll('span.price-installment');
      os_bodys = document.querySelectorAll('div.os-body');
      os_headings = document.querySelectorAll("div.os-heading");
      installment_headings = document.querySelectorAll(
          "div.klarna-afterpay-installment"
      );
      payment_badges = document.querySelectorAll("span.payment_badges");
      recharge_badge = document.querySelectorAll("span.recharge-icon");
      recharge_badge.forEach(function (rc_badge) {
          rc_badge.style.display = "none";
        });
      payment_badges.forEach(function (payment_badge) {
          payment_badge.style.display = "flex";
        });
      installment_headings.forEach(function (installment_heading) {
          installment_heading.style.display = "block";
        });
      kicker_headings.forEach(function(kicker_heading) {
          kicker_heading.textContent = '';
          kicker_heading.textContent += "Shop Now, Pay Later";
      });
      pmt_headings.forEach(function(pmt_heading) {
          pmt_heading.textContent = '';
          pmt_heading.textContent += "Pay 4 installments of ";
      });
      os_headings.forEach(function (os_heading) {
          os_heading.textContent = '';
        });
      os_bodys.forEach(function(os_body) {
          os_body.innerHTML = '';
          os_body.innerHTML += "<ul class='os-list'><li><strong>1.</strong> Add item(s) to your cart</li><li><strong>2.</strong> Go to checkout and choose Klarna or Afterpay</li><li><strong>3.</strong> Enter your debit or credit card information</li><li><strong>4.</strong> Pay later in 4 installments. The first payment is taken when the order is processed andthe remaining 3 are automatically taken at scheduled intervals.</li></ul><div style=font-size:12px>*See payment <a target='_blank' href='https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/sliceitinx'><span style='color:#5E93DB'>terms</span></a>. A higher initial payment may be required for some consumers. CA resident loans made or arranged pursuant to a California Financing Law license.</div><a target='_blank' href='https://www.dermalogica.com/pages/afterpay'><span style='color:#5E93DB'>Learn more</span></a>";
      });
}
  // Mobile layout: Bottom Modal
  if (window.innerWidth < 600) {
    var osMobile = document.getElementById("os-modal-mobile");
  // When the user clicks the button, open the modal

  if (!osMobile || !infoIcon || !closeIconMobile) return;

  infoIcon.addEventListener('click', function () {
  osMobile.style.display = "block";
  addInstallmentDetails();
    });

    closeIconMobile.onclick = function () {
    osMobile.style.display = "none";
              };

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
                  if (event.target == osMobile) {
                    osMobile.style.display = "none";
                  }
                };
  };

  // Desktop layout: Modal
  if (window.innerWidth >= 600) {
    if (infoIcon){
  infoIcon.addEventListener('click', function () {
    if (!onSiteContainer.classList.contains("klarna")) {
      setTimeout(function() {

    onSiteContainer.classList.add('show');
    onSiteContainer.classList.add('klarna');
    parentContainer.classList.remove('announcement-popup-container');
    
    addInstallmentDetails();
    var iconRect = infoIcon.getBoundingClientRect();
    var iconTop = iconRect.top  + window.scrollY; 
    var iconLeft = iconRect.left + window.scrollX; 
    onSiteContainer.style.position = 'absolute';
    onSiteContainer.style.top = (iconTop - 200) + 'px'; 
    onSiteContainer.style.left = (iconLeft - 350) +'px';
    onSiteContainer.style.display = 'block';

     }, 100);
    }
  });
}
    closeIcon.addEventListener('click', function (event) {
      onSiteContainer.style.display = 'none';
      onSiteContainer.classList.remove('show');
      onSiteContainer.classList.remove('klarna');
    });
      var infoIcon2 = document.querySelector('.info-icon');
      function isClickOutsideElement(element, event) {
        let target = event.target;
        while (target !== null) {
          if (target === element) {
            return false; 
          }
          target = target.parentNode;
        }
        return true; 
      }

      document.addEventListener('click', function (event) {
        if (onSiteContainer.classList.contains('klarna')) {
          if (isClickOutsideElement(infoIcon2, event) && isClickOutsideElement(onSiteContainer, event)) {
            console.log('clicked!-4');
            onSiteContainer.style.display = 'none';
            onSiteContainer.classList.remove("show");
            onSiteContainer.classList.remove("klarna");

          }
        }
      });
    
  }

}
setTimeout(function() {
klarnaAfterToolTip();
}, 4000);

document.addEventListener('change', function(event) {
  var target = event.target;
  if (target.tagName === 'INPUT' && target.getAttribute('name') === 'size') {
    var parent = target.closest('.no-js-hidden'); 
    if (parent) {
      setTimeout(function() {
        klarnaAfterToolTip();
      }, 3000);
    }
  }
});


document.addEventListener('change', function(event) {
  var target = event.target;

  // Check if the target is an input with the name 'updates[]'
  if (target.tagName === 'INPUT' && target.getAttribute('name') === 'updates[]') {
    var parent = target.closest('.quantity'); 
    if (parent) {
      setTimeout(function() {
        klarnaAfterToolTip(); 
      }, 5000);
    }
  }
});

document.addEventListener('click', function(event) {
  var target = event.target;
  var deleteItem = target.closest('a[aca-line]');

  // Proceed if such an <a> element exists
  if (deleteItem) {
    setTimeout(function() {
      klarnaAfterToolTip(); 
    }, 5000);
  }
});


// setInterval(function(){
//   klarnaAfterToolTip();
// },500);